import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';

// Shared modules
import { UIModule } from '../ui.module';
import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { SharedServicesModule } from '../shared-services.module';

import { XsollaService } from '../core/xsolla.service';

// Module componnets.
import { IconPixelComponent } from './icon-pixel.component';
import { StorePixelComponent } from './store-pixel.component';
import { DlgStorePixelComponent } from './dlg-store-pixel';
import { ShowDlgStorePixelService } from './show-dlg-store-pixel.service';

import { IconCpuUnlockComponent } from './icon-cpu-unlock.component';
import { StoreCpuUnlockComponent } from './store-cpu-unlock.component';
import { DlgStoreCpuUnlockComponent } from './dlg-store-cpu-unlock';
import { ShowDlgStoreCpuUnlockService } from './show-dlg-store-cpu-unlock.service';

import { IconAccessKeyComponent } from './icon-access-key.component';
import { StoreAccessKeyComponent } from './store-access-key.component';
import { DlgStoreAccessKeyComponent } from './dlg-store-access-key';
import { ShowDlgStoreAccessKeyService } from './show-dlg-store-access-key.service';

import { SuccessBuyComponent } from './success-buy.component';
import { DlgSuccessBuyComponent } from './dlg-success-buy';
import { ShowDlgSuccessBuyService } from './show-dlg-success-buy.service';

import { TransferComponent } from './transfer.component';
import { DlgTransferComponent } from './dlg-transfer';
import { ShowDlgTransferService } from './show-dlg-transfer.service';

import { GetAccessComponent } from './get-access.component';
import { DlgGetAccessComponent } from './dlg-get-access';
import { ShowDlgGetAccessService } from './show-dlg-get-access.service';

import { CouponComponent } from './coupon.component';
import { DlgCouponComponent } from './dlg-coupon';
import { ShowDlgCouponService } from './show-dlg-coupon.component';

// Module directives.

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSliderModule,
        MatFormFieldModule,

        // Shared modules
        UIModule,
        CoreModule,
        SharedModule,
        SharedServicesModule
    ],
    declarations: [
        IconPixelComponent,
        StorePixelComponent,
        DlgStorePixelComponent,

        IconCpuUnlockComponent,
        StoreCpuUnlockComponent,
        DlgStoreCpuUnlockComponent,

        IconAccessKeyComponent,
        StoreAccessKeyComponent,
        DlgStoreAccessKeyComponent,

        SuccessBuyComponent,
        DlgSuccessBuyComponent,

        TransferComponent,
        DlgTransferComponent,

        GetAccessComponent,
        DlgGetAccessComponent,

        CouponComponent,
        DlgCouponComponent
    ],
    exports: [
        IconPixelComponent,
        StorePixelComponent,
        DlgStorePixelComponent,

        IconCpuUnlockComponent,
        StoreCpuUnlockComponent,
        DlgStoreCpuUnlockComponent,

        IconAccessKeyComponent,
        StoreAccessKeyComponent,
        DlgStoreAccessKeyComponent,

        SuccessBuyComponent,
        DlgSuccessBuyComponent,

        TransferComponent,
        DlgTransferComponent,

        GetAccessComponent,
        DlgGetAccessComponent,

        CouponComponent,
        DlgCouponComponent
    ],
    providers: [
        XsollaService,

        ShowDlgStorePixelService,
        ShowDlgStoreCpuUnlockService,
        ShowDlgStoreAccessKeyService,
        ShowDlgSuccessBuyService,
        ShowDlgTransferService,
        ShowDlgGetAccessService,
        ShowDlgCouponService
    ],
    entryComponents: [
        IconPixelComponent,
        IconCpuUnlockComponent,
        IconAccessKeyComponent,

        DlgStorePixelComponent,
        DlgStoreCpuUnlockComponent,
        DlgStoreAccessKeyComponent,
        DlgSuccessBuyComponent,
        DlgTransferComponent,
        DlgGetAccessComponent,
        DlgCouponComponent
    ]
})
export class SharedDialogsModule {
}
